const detectSupportNativeHls = () => {
  const video = document.createElement("video");
  return !!video.canPlayType("application/vnd.apple.mpegURL");
};

export const isSupportNativeHls = detectSupportNativeHls();
